import Vue from 'vue'
import elementLocale from 'element-ui/lib/locale'
import elementLangEn from 'element-ui/lib/locale/lang/en'
import elementLangZh from 'element-ui/lib/locale/lang/zh-CN'
import messages from './messages'

const ELEMENT_LANG = {
  'en-US': elementLangEn,
  'zh-CN': elementLangZh
}

export function syncElementUILocale(locale) {
  const lang = ELEMENT_LANG[locale] || ELEMENT_LANG['en-US']
  elementLocale.use(lang)
}

const STORAGE_KEY = 'glt-crm-locale'
const DEFAULT_LOCALE = localStorage.getItem(STORAGE_KEY) || 'en-US'

export const localeState = Vue.observable({
  locale: DEFAULT_LOCALE
})

export const supportedLocales = [
  { value: 'en-US', label: 'English' },
  { value: 'zh-CN', label: '简体中文' }
]

function interpolate(text, params) {
  if (!params || typeof text !== 'string') return text
  return text.replace(/\{(\w+)\}/g, (_, key) => {
    const value = params[key]
    return value === undefined || value === null ? '' : String(value)
  })
}

function getNestedValue(obj, path) {
  const parts = String(path || '').split('.')
  let cursor = obj
  for (const part of parts) {
    if (cursor == null || typeof cursor !== 'object' || !(part in cursor)) {
      return undefined
    }
    cursor = cursor[part]
  }
  return cursor
}

export function getLocale() {
  return localeState.locale
}

export function setLocale(locale) {
  if (!messages[locale]) return
  localeState.locale = locale
  localStorage.setItem(STORAGE_KEY, locale)
  syncElementUILocale(locale)
}

export function t(path, params) {
  const current = messages[getLocale()] || messages['en-US']
  const fallback = messages['en-US']
  const hit = getNestedValue(current, path)
  if (hit != null) {
    return interpolate(hit, params)
  }
  const fallbackHit = getNestedValue(fallback, path)
  if (fallbackHit != null) {
    return interpolate(fallbackHit, params)
  }
  return path
}

export function installI18n(VueCtor) {
  VueCtor.mixin({
    computed: {
      $locale() {
        return localeState.locale
      },
      $languageOptions() {
        return supportedLocales
      }
    },
    methods: {
      $t(key, params) {
        return t(key, params)
      },
      $setLocale(locale) {
        setLocale(locale)
      }
    }
  })
}
